<ng-container
  [ngTemplateOutlet]="data.template"
  [ngTemplateOutletContext]="{
    tournament: data.tournament,
    opened: true
  }"
>
</ng-container>
